if (!customElements.get("section-selected")) {
  customElements.define(
    "section-selected",
    class SectionSelected extends HTMLElement {
      constructor() {
        super();

        this.productSelect = this.querySelector(".product-select");
        this.productSelectText = this.querySelector(".product-select__text");
        this.productList = this.querySelector(".product-list");
        this.productItems = this.querySelectorAll(".product-item");
        this.firstButton = this.querySelector(".btn-change-url");

        this.init();
      }

      init() {
        this.setupAccessibility();

        if (this.productItems.length > 0) {
          const firstProductItem = this.productItems[0];
          firstProductItem.classList.add("active");
          this.selectProduct(firstProductItem, false);
        }

        if (this.productSelectText) {
          this.productSelectText.addEventListener("click", () =>
            this.handleProductToggle()
          );

          this.productSelectText.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.handleProductToggle();
            }
          });
        }

        this.productItems.forEach((item, index) => {
          item.setAttribute("tabindex", "0");
          item.setAttribute("id", `product-item-${index}`);

          item.addEventListener("click", () => this.selectProduct(item));

          item.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.selectProduct(item);
            } else if (e.key === "ArrowDown") {
              e.preventDefault();
              const nextItem =
                this.productItems[index + 1] || this.productItems[0];
              nextItem.focus();
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              const prevItem =
                this.productItems[index - 1] ||
                this.productItems[this.productItems.length - 1];
              prevItem.focus();
            } else if (e.key === "Escape") {
              e.preventDefault();
              this.closeDropdown(this.productList);
              this.productSelectText.focus();
            }
          });
        });

        document.addEventListener("click", (event) => {
          if (!event.target.closest("select-options")) {
            this.closeAllDropdowns();
          }
        });

        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            this.closeAllDropdowns();
          }
        });

        window.addEventListener("resize", () => {
          this.checkDropdownPosition(this.productList);
        });

        if (window.innerWidth <= 767) {
          this.checkDropdownPosition(this.productList);
        }
      }

      setupAccessibility() {
        if (this.productSelectText) {
          this.productSelectText.setAttribute("tabindex", "0");
        }
      }

      handleProductToggle() {
        this.toggleDropdown(this.productList);
      }

      selectProduct(item, shouldFocus = true) {
        const text = item.textContent.trim();
        const url = item.getAttribute("data-url");

        this.productItems.forEach((i) => i.classList.remove("active"));
        item.classList.add("active");

        this.productSelectText.textContent = text;
        this.productSelectText.appendChild(this.createSvgIcon());
        this.productSelectText.setAttribute("data-url", url);

        if (this.firstButton && url) {
          this.firstButton.href = url;
        }

        this.closeDropdown(this.productList);

        if (shouldFocus) {
          this.productSelectText.focus();
        }
      }

      createSvgIcon() {
        const svg = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        svg.setAttribute("width", "13");
        svg.setAttribute("height", "7");
        svg.setAttribute("viewBox", "0 0 13 7");
        svg.style.setProperty("--width", "1.3rem");
        svg.classList.add(
          "icon",
          "icon-down",
          "icon-rotate",
          "transition-drawer",
          "w-custom",
          "flex-auto"
        );

        const use = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "use"
        );
        use.setAttribute("href", "#icon-arrow-down-mb");
        svg.appendChild(use);

        return svg;
      }

      toggleDropdown(dropdown) {
        if (!dropdown) return;

        const isExpanded = dropdown.classList.toggle("active");

        if (isExpanded) {
          this.checkDropdownPosition(dropdown);

          setTimeout(() => {
            const firstItem =
              dropdown.querySelector(".product-item.active") ||
              dropdown.querySelector(".product-item");

            if (firstItem) firstItem.focus();
          }, 100);
        }
      }

      checkDropdownPosition(dropdown) {
        if (!dropdown) return;

        const viewportWidth = window.innerWidth;
        dropdown.classList.remove(
          "dropdown-right",
          "dropdown-left",
          "dropdown-mobile"
        );

        if (viewportWidth <= 767) {
          dropdown.classList.add("dropdown-mobile");
          const dropdownRect = dropdown.getBoundingClientRect();

          if (dropdownRect.right > viewportWidth) {
            dropdown.classList.add("dropdown-right");
          }

          if (dropdownRect.left < 0) {
            dropdown.classList.add("dropdown-left");
          }
        }
      }

      closeDropdown(dropdown) {
        if (!dropdown) return;
        dropdown.classList.remove("active");
      }

      closeAllDropdowns() {
        this.closeDropdown(this.productList);
      }
    }
  );
}